// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvoiceActivityDrawer {
  color: var(--bs-primary);
}
.InvoiceActivityDrawer .Drawer-Header .Drawer-Title {
  text-transform: uppercase;
  font-size: 2rem;
}
.InvoiceActivityDrawer .ActivityList .ActivityItem {
  color: var(--bs-primary);
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoiceHistory/styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AACI;EACE,yBAAA;EACA,eAAA;AACN;AAEE;EACE,wBAAA;EACA,eAAA;AAAJ","sourcesContent":[".InvoiceActivityDrawer {\n  color: var(--bs-primary);\n  .Drawer-Header {\n    .Drawer-Title {\n      text-transform: uppercase;\n      font-size: 2rem;\n    }\n  }\n  .ActivityList .ActivityItem {\n    color: var(--bs-primary);\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
